export default __webpack_public_path__ + "1eb63a506118541e3c60d5201734fd18.svg";